import React from "react";

export default function Footer() {
  return (
    <div className="main-footer">
      <div></div>
      <div>&copy; 2023 - PetroChina - Digital HSSE Passport | Version: 1.0.231214</div>
    </div>
  )
}